import {
  CreateBusinessPlanReportDto,
  GetBusinessPlanReportDto,
  GetBusinessPlanReportGoalsDto,
  IFivGoal,
  IFivReport,
  IUploadBusinessPlanReport,
} from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';

export class BusinessPlanApi {
  static uploadBusinessPlanReport(
    goalGroupId: string,
    formData: FormData,
  ): Promise<AxiosResponse<IFivReport[]>> {
    return AdmiralApi.apiCall<IFivReport[]>({
      method: 'POST',
      url: `${BASE_URL}/businessplan/upload/${goalGroupId}`,
      data: formData,
    });
  }

  static validateUploadedBusinessPlanReport(
    uploadBusinessPlanReport: IUploadBusinessPlanReport,
  ): Promise<AxiosResponse<IUploadBusinessPlanReport>> {
    return AdmiralApi.apiCall<IUploadBusinessPlanReport>({
      method: 'POST',
      url: `${BASE_URL}/businessplan/validate`,
      data: uploadBusinessPlanReport,
    });
  }

  static createBusinessPlanReport(dto: CreateBusinessPlanReportDto): Promise<AxiosResponse> {
    return AdmiralApi.apiCall<IFivReport>({
      method: 'POST',
      url: `${BASE_URL}/businessplan/report/create`,
      data: dto,
    });
  }

  static getLatestBusinessPlanReport(
    getBusinessplanReportDto: GetBusinessPlanReportDto,
  ): Promise<AxiosResponse<IFivReport[]>> {
    return AdmiralApi.apiCall<IFivReport[]>({
      method: 'POST',
      url: `${BASE_URL}/businessplan/latest-reports`,
      data: getBusinessplanReportDto,
    });
  }

  static getLatestBusinessPlanReportGoals(
    getBusinessplanReportGoalsDto: GetBusinessPlanReportGoalsDto,
  ): Promise<AxiosResponse<IFivGoal[]>> {
    return AdmiralApi.apiCall<IFivGoal[]>({
      method: 'POST',
      url: `${BASE_URL}/businessplan/report/goals`,
      data: getBusinessplanReportGoalsDto,
    });
  }
}
